import React from "react";
import {
  FiBookOpen,
  FiGlobe,
  FiMail,
  FiSend,
  FiShield,
  FiUsers,
  FiVideo,
} from "react-icons/fi";
import AppCard from "./AppCard";
import PrivacyChannelRow from "./PrivacyChannelRow";
import { PRIVACY_CHANNELS } from "../../../../features/privacy/definitions";

const CHANNEL_ICONS = {
  website: FiGlobe,
  newsletter: FiMail,
  socials: FiUsers,
  promotionalMaterials: FiSend,
  internalPublications: FiBookOpen,
  localMedia: FiVideo,
  videoRecordings: FiVideo,
};

const PrivacyChannelList = ({ t, channels, setChannels, visibilitySlot, footer }) => (
  <AppCard className="overflow-hidden">
    {PRIVACY_CHANNELS.map(({ key: channelKey, labelKey }, index) => {
      const ChannelIcon = CHANNEL_ICONS[channelKey] || FiShield;
      const checked = !!channels[channelKey];

      return (
        <PrivacyChannelRow
          key={channelKey}
          t={t}
          channelKey={channelKey}
          labelKey={labelKey}
          icon={ChannelIcon}
          checked={checked}
          separated={index > 0}
          onChange={(nextChecked) =>
            setChannels((prev) => ({ ...prev, [channelKey]: nextChecked }))
          }
        />
      );
    })}

    {visibilitySlot}
    {footer}
  </AppCard>
);

export default PrivacyChannelList;
